<template>
  <section id="dashboard-analytics">
    <BRow class="match-height">
      <BCol cols="12">
        <GeneralRadialBarChart :getChartData="getUsersByCreateDate">
          <template #title> نرخ تبدیل سیستم </template>
        </GeneralRadialBarChart>
      </BCol>
      <BCol lg="6" md="12">
        <GeneralPieChart :getChartData="getIncomeOutcomePercentChartData">
          <template #title>
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <p>منابع درآمد (درصد)</p>
              <b-link
                to="/dashboard/analytics/income-source-percentage"
                class="btn btn-success"
                >جزئیات</b-link
              >
            </div>
          </template>
        </GeneralPieChart>
      </BCol>
      <BCol lg="6" md="12">
        <GeneralPieChart :getChartData="getIncomeOutcomeChartData">
          <template #title>
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              منابع درآمد (تومان)
              <b-link
                to="/dashboard/analytics/income-source-cash"
                class="btn btn-success"
              >
                جزئیات
              </b-link>
            </div>
          </template>
        </GeneralPieChart>
      </BCol>
      <BCol cols="12">
        <UserReportsByDateTime isRenderingLinkBtn></UserReportsByDateTime>
      </BCol>
      <BCol cols="12">
        <GeneralLineChart :getChartData="getUserActivitiesReportByDay">
          <template #title>
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <span> فعالیت کاربر ها بر اساس روز </span>
              <span>
                از
                {{
                  customFullDateConvert(
                    new Date(
                      new Date().setMonth(new Date().getMonth() - 1)
                    ).toISOString()
                  )
                }}
              </span>
            </div>
          </template>
        </GeneralLineChart>
      </BCol>
      <BCol cols="12">
        <GeneralLineChart :getChartData="getUserActivitiesReportByWeek">
          <template #title>
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <span> فعالیت کاربر ها بر اساس هفته </span>
              <span>
                از
                {{
                  customFullDateConvert(
                    new Date(
                      new Date().setMonth(new Date().getMonth() - 2)
                    ).toISOString()
                  )
                }}
              </span>
            </div>
          </template>
        </GeneralLineChart>
      </BCol>
      <BCol cols="12">
        <GeneralLineChart :getChartData="getUserActivitiesReportByMonth">
          <template #title>
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <span> فعالیت کاربر ها بر اساس ماه </span>
              <span>
                از
                {{
                  customFullDateConvert(
                    new Date(
                      new Date().setMonth(new Date().getMonth() - 12)
                    ).toISOString()
                  )
                }}
              </span>
            </div>
          </template>
        </GeneralLineChart>
      </BCol>
      <BCol cols="12">
        <GeneralLineChart :getChartData="getUserActivitiesReportByYear">
          <template #title>
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <span> فعالیت کاربر ها بر اساس سال </span>
              <span>
                از
                {{
                  customFullDateConvert(
                    new Date(
                      new Date().setFullYear(new Date().getFullYear() - 3)
                    ).toISOString()
                  )
                }}
              </span>
            </div>
          </template>
        </GeneralLineChart>
      </BCol>
      <BCol cols="12" md="6">
        <GeneralPolarAreaChart :getChartData="getPriceCategoryChartData">
          <template #title>
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              زمان رزرو شده در هر گروه‌بندی (دقیقه)
              <!-- <b-link
                to="/dashboard/analytics/income-source-cash"
                class="btn btn-success"
              >
                جزئیات
              </b-link> -->
            </div>
          </template>
        </GeneralPolarAreaChart>
      </BCol>
      <BCol cols="12" md="6">
        <GeneralPolarAreaChart :getChartData="getPriceCategoryCountChartData">
          <template #title>
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              تعداد جلسات رزرو شده در هر گروه‌بندی (جلسه)
              <b-link
                to="/dashboard/analytics/reservation-count-by-category"
                class="btn btn-success"
                >جزئیات</b-link
              >
            </div>
          </template>
        </GeneralPolarAreaChart>
      </BCol>
      <BCol cols="12">
        <GeneralBarChart :getChartData="getMasterScheduleMostCountChartData">
          <template #title>اساتید برتر (بر اساس تعداد جلسه)</template>
        </GeneralBarChart>
      </BCol>
      <BCol cols="12">
        <GeneralLineChart :getChartData="getWeekChartData">
          <template #title>
            <div
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <span> کلاس های برگزار شده در روز های هفته </span>
              <b-link
                to="/dashboard/analytics/reservation-count-by-weekday"
                class="btn btn-success"
                >جزئیات</b-link
              >
            </div>
          </template>
        </GeneralLineChart>
      </BCol>
      <BCol cols="12">
        <GeneralDonutChart
          :getChartData="getMostSchaduleCountByScheduleLoyalty"
        >
          <template #title>تعداد جلسات رزرو شده بر اساس تخفیف وفاداری</template>
        </GeneralDonutChart>
      </BCol>
    </BRow>
  </section>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    async getUsersByCreateDate(
      _this,
      startCreateDate = new Date(
        new Date().getTime() - 2629746000
      ).toISOString(),
      endCreateDate = new Date().toISOString()
    ) {
      try {
        let getUserByCreateDate = new GetUserByCreateDate(_this);
        getUserByCreateDate.setRequestParamDataObj({
          startCreateDate,
          endCreateDate,
        });
        await getUserByCreateDate.fetch((res) => {
          if (_this.valueArray) {
            _this.valueArray = [res[0].value, res[1].value];
            _this.chartOptions.series = [
              (_this.valueArray[0] / _this.valueArray[0]) * 100,
              ((_this.valueArray[1] / _this.valueArray[0]) * 100).toFixed(0),
            ];
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getMostSchaduleCountByScheduleLoyalty(_this) {
      try {
        let getMostSchaduleCountByScheduleLoyaltyDiscount =
          new GetMostSchaduleCountByScheduleLoyaltyDiscount(_this);
        getMostSchaduleCountByScheduleLoyaltyDiscount.setRequestParamDataObj(
          _this.chartPayload
        );
        await getMostSchaduleCountByScheduleLoyaltyDiscount.fetch((res) => {
          _this.chartOptions.labels = [];
          _this.chartOptions.series = [];
          if (res.length > 0) {
            if (res.length > 0) {
              res.forEach((item) => {
                _this.chartOptions.labels.push(item.title);
                _this.chartOptions.series.push(item.value);
              });
              _this.isRenderingChart = true;
            }
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getWeekChartData(_this) {
      try {
        let getMostSchaduleCountByDayOfWeek =
          new GetMostSchaduleCountByDayOfWeek(_this);
        getMostSchaduleCountByDayOfWeek.setRequestParamDataObj(
          _this.chartPayload
        );
        await getMostSchaduleCountByDayOfWeek.fetch((res) => {
          _this.chartOptions.series = [];
          if (res.length > 0) {
            let myDataArray = [];
            let myLabelArray = [];
            if (res.length > 0) {
              res.forEach((item) => {
                myLabelArray.push(item.title);
                myDataArray.push(item.value);
              });
              _this.chartOptions.series.push({
                data: myDataArray,
              });
              _this.chartOptions["xaxis"]["categories"] = myLabelArray;
              _this.isRenderingChart = true;
            }
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getMasterScheduleMostCountChartData(_this) {
      try {
        let getMostSchaduleCountByMaster = new GetMostSchaduleCountByMaster(
          _this
        );
        getMostSchaduleCountByMaster.setRequestParamDataObj(_this.chartPayload);
        await getMostSchaduleCountByMaster.fetch((res) => {
          // _this.chartOptions["series"] = [];
          let myDataArray = [];
          let myLabelArray = [];
          if (res.length > 0) {
            res.forEach((item) => {
              myLabelArray.push(item.title);
              myDataArray.push(item.value);
            });
            _this.chartOptions.series.push({
              data: myDataArray,
            });

            _this.chartOptions["xaxis"]["categories"] = myLabelArray;

            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getPriceCategoryCountChartData(_this) {
      try {
        let getMostSchaduleCountByPriceCategory =
          new GetMostSchaduleCountByPriceCategory(_this);
        getMostSchaduleCountByPriceCategory.setRequestParamDataObj(
          _this.chartPayload
        );
        await getMostSchaduleCountByPriceCategory.fetch((res) => {
          _this.chartOptions.labels = [];
          _this.chartOptions.series = [];
          if (res.length > 0) {
            res.forEach((item) => {
              _this.chartOptions.labels.push(item.title);
              _this.chartOptions.series.push(item.value);
            });
            _this.chartOptions.dataLabels["formatter"] = function (val, opts) {
              return `${Intl.NumberFormat("en-US").format(
                +opts["w"]["globals"]["series"][opts["seriesIndex"]]
              )} جلسه`;
            };
            _this.chartOptions["tooltip"]["y"] = {
              formatter: (value) =>
                `${Intl.NumberFormat("en-US").format(+value)} جلسه`,
            };
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getPriceCategoryChartData(_this) {
      try {
        let getMostSchaduleMinuteByPriceCategory =
          new GetMostSchaduleMinuteByPriceCategory(_this);
        getMostSchaduleMinuteByPriceCategory.setRequestParamDataObj(
          _this.chartPayload
        );
        await getMostSchaduleMinuteByPriceCategory.fetch((res) => {
          _this.chartOptions.labels = [];
          _this.chartOptions.series = [];
          if (res.length > 0) {
            res.forEach((item) => {
              _this.chartOptions.labels.push(item.title);
              _this.chartOptions.series.push(item.value);
            });
            _this.chartOptions.dataLabels["formatter"] = function (val, opts) {
              return `${Intl.NumberFormat("en-US").format(
                +opts["w"]["globals"]["series"][opts["seriesIndex"]]
              )} دقیقه`;
            };
            _this.chartOptions["tooltip"]["y"] = {
              formatter: (value) =>
                `${Intl.NumberFormat("en-US").format(+value)} دقیقه`,
            };
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getIncomeOutcomeChartData(_this) {
      try {
        let getIncomeOutcomeChart = new GetIncomeOutcomeChart(_this);
        getIncomeOutcomeChart.setRequestParamDataObj(_this.chartPayload);
        await getIncomeOutcomeChart.fetch((res) => {
          _this.chartOptions.labels = [];
          _this.chartOptions.series = [];
          if (res.length > 0) {
            res.forEach((item) => {
              _this.chartOptions.labels.push(item.title);
              _this.chartOptions.series.push(item.value);
            });
            _this.chartOptions.dataLabels["formatter"] = function (val, opts) {
              return `${Intl.NumberFormat("en-US").format(
                +opts["w"]["globals"]["series"][opts["seriesIndex"]]
              )} تومان`;
            };
            _this.chartOptions["tooltip"]["y"] = {
              formatter: (value) =>
                `${Intl.NumberFormat("en-US").format(+value)} تومان`,
            };
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getUserActivitiesReportByDay(_this) {
      try {
        let oneMonthAgo = new Date(
          new Date().setMonth(new Date().getMonth() - 1)
        ).toISOString();
        let userActivitiesReportByDateTime = new UserActivitiesReportByDateTime(
          _this
        );
        userActivitiesReportByDateTime.setRequestParamDataObj({
          startDate: oneMonthAgo,
          reportType: 4,
        });
        await userActivitiesReportByDateTime.fetch((res) => {
          _this.chartOptions.series = [];
          let myDataArray = [];
          let myLabelArray = [];
          if (
            res &&
            res.data &&
            res.data.report &&
            res.data.report.length > 0
          ) {
            res.data.report.forEach((item) => {
              myLabelArray.push(`${this.customFullDateConvert(item.date)}`);
              myDataArray.push(item.totalCount);
            });
            _this.chartOptions.series.push({
              data: myDataArray,
            });
            _this.chartOptions.colors.unshift("#fa1db8ee");
            _this.chartOptions["tooltip"]["y"]["title"]["formatter"] = (
              seriesName
            ) => " کاربران فعال: ";
            _this.chartOptions["xaxis"]["title"]["text"] = "روز";
            _this.chartOptions["xaxis"]["categories"] = myLabelArray;
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getUserActivitiesReportByWeek(_this) {
      try {
        let oneMonthAgo = new Date(
          new Date().setMonth(new Date().getMonth() - 2)
        ).toISOString();
        let userActivitiesReportByDateTime = new UserActivitiesReportByDateTime(
          _this
        );
        userActivitiesReportByDateTime.setRequestParamDataObj({
          startDate: oneMonthAgo,
          reportType: 1,
        });
        await userActivitiesReportByDateTime.fetch((res) => {
          _this.chartOptions.series = [];
          let myDataArray = [];
          let myLabelArray = [];
          if (
            res &&
            res.data &&
            res.data.report &&
            res.data.report.length > 0
          ) {
            res.data.report.forEach((item) => {
              myLabelArray.push(
                `${this.customFullDateConvert(
                  item.startOfInterval
                )} - ${this.customFullDateConvert(
                  new Date(
                    new Date(item.startOfInterval).setDate(
                      new Date(item.startOfInterval).getDate() - 7
                    )
                  )
                )}`
              );
              myDataArray.push(item.totalCount);
            });
            _this.chartOptions.series.push({
              data: myDataArray,
            });
            _this.chartOptions["tooltip"]["y"]["title"]["formatter"] = (
              seriesName
            ) => " کاربران فعال: ";
            _this.chartOptions["xaxis"]["title"]["text"] = "بازه‌ی هفته";
            _this.chartOptions["xaxis"]["categories"] = myLabelArray;
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getUserActivitiesReportByMonth(_this) {
      try {
        let TwelveMonthAgo = new Date(
          new Date().setMonth(new Date().getMonth() - 12)
        ).toISOString();
        let userActivitiesReportByDateTime = new UserActivitiesReportByDateTime(
          _this
        );
        userActivitiesReportByDateTime.setRequestParamDataObj({
          startDate: TwelveMonthAgo,
          reportType: 2,
        });
        await userActivitiesReportByDateTime.fetch((res) => {
          _this.chartOptions.series = [];
          let myDataArray = [];
          let myLabelArray = [];
          if (
            res &&
            res.data &&
            res.data.report &&
            res.data.report.length > 0
          ) {
            res.data.report.forEach((item) => {
              myLabelArray.push(
                `${this.customConvertMonth(
                  item.startOfInterval
                )} - ${this.customConvertYear(item.startOfInterval)}`
              );
              myDataArray.push(item.totalCount);
            });
            _this.chartOptions.series.push({
              data: myDataArray,
            });
            _this.chartOptions.colors.unshift("#005f96");
            _this.chartOptions["tooltip"]["y"]["title"]["formatter"] = (
              seriesName
            ) => " کاربران فعال: ";
            _this.chartOptions["xaxis"]["title"]["text"] = "ماه ها";
            _this.chartOptions["xaxis"]["categories"] = myLabelArray;
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getUserActivitiesReportByYear(_this) {
      try {
        let twoYearsAgo = new Date(
          new Date().setFullYear(new Date().getFullYear() - 3)
        ).toISOString();
        let userActivitiesReportByDateTime = new UserActivitiesReportByDateTime(
          _this
        );
        userActivitiesReportByDateTime.setRequestParamDataObj({
          startDate: twoYearsAgo,
          reportType: 3,
        });
        await userActivitiesReportByDateTime.fetch((res) => {
          _this.chartOptions.series = [];
          let myDataArray = [];
          let myLabelArray = [];
          if (
            res &&
            res.data &&
            res.data.report &&
            res.data.report.length > 0
          ) {
            res.data.report.forEach((item) => {
              myLabelArray.push(item.year);
              myDataArray.push(item.totalCount);
            });
            _this.chartOptions.series.push({
              data: myDataArray,
            });
            _this.chartOptions.colors.unshift("#5c0064");
            _this.chartOptions["tooltip"]["y"]["title"]["formatter"] = (
              seriesName
            ) => " کاربران فعال: ";
            _this.chartOptions["xaxis"]["title"]["text"] = "سال ها";
            _this.chartOptions["xaxis"]["categories"] = myLabelArray;
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getIncomeOutcomePercentChartData(_this) {
      try {
        let getIncomeOutcomePercentChart = new GetIncomeOutcomePercentChart(
          _this
        );
        getIncomeOutcomePercentChart.setRequestParamDataObj(_this.chartPayload);
        await getIncomeOutcomePercentChart.fetch((res) => {
          _this.chartOptions.labels = [];
          _this.chartOptions.series = [];
          if (res.length > 0) {
            res.forEach((item) => {
              _this.chartOptions.labels.push(item.title);
              _this.chartOptions.series.push(item.value);
            });
            _this.chartOptions["tooltip"]["y"] = {
              formatter: (value) => `${(+value).toFixed(2)}%`,
            };
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    kFormatter,
  },
  mixins: [timeConvertUtils],
  components: {
    BRow,
    BCol,
    BLink,
    AnalyticsAvgSessions,
    StatisticCardWithAreaChart,
    AnalyticsSupportTracker,
    AnalyticsTimeline,
    AnalyticsSalesRadarChart,
    AnalyticsAppDesign,
    InvoiceList,
    GeneralPieChart,
    GeneralPolarAreaChart,
    GeneralBarChart,
    GeneralLineChart,
    GeneralDonutChart,
    GeneralRadialBarChart,
    UserReportsByDateTime,
  },
};
import { BRow, BCol, BLink } from "bootstrap-vue";
import StatisticCardWithAreaChart from "@core/components/statistics-cards/StatisticCardWithAreaChart.vue";
import { kFormatter } from "@core/utils/filter";
import InvoiceList from "@/views/apps/invoice/invoice-list/InvoiceList.vue";
import AnalyticsAvgSessions from "./AnalyticsAvgSessions.vue";
import AnalyticsSupportTracker from "./AnalyticsSupportTracker.vue";
import AnalyticsTimeline from "./AnalyticsTimeline.vue";
import AnalyticsSalesRadarChart from "./AnalyticsSalesRadarChart.vue";
import AnalyticsAppDesign from "./AnalyticsAppDesign.vue";
import GeneralLineChart from "./UserReport/GeneralLineChart.vue";
import GeneralPieChart from "./IncomeOutcome/GeneralPieChart.vue";
import GeneralPolarAreaChart from "./UserReport/GeneralPolarAreaChart.vue";
import GeneralBarChart from "./UserReport/GeneralBarChart.vue";
import GeneralDonutChart from "./UserReport/GeneralDonutChart.vue";
import GeneralRadialBarChart from "./UserReport/GeneralRadialBarChart.vue";
import UserReportsByDateTime from "@/views/components/Reports/UserReportsByDateTime.vue";
import {
  GetMostSchaduleMinuteByPriceCategory,
  GetMostSchaduleCountByPriceCategory,
  GetMostSchaduleCountByMaster,
  GetMostSchaduleCountByDayOfWeek,
  GetMostSchaduleCountByScheduleLoyaltyDiscount,
  GetUserByCreateDate,
} from "@/libs/Api/UserReport";
import {
  GetIncomeOutcomePercentChart,
  GetIncomeOutcomeChart,
} from "@/libs/Api/IncomeOutcomeTransaction";
import { UserActivitiesReportByDateTime } from "@/libs/Api/Users";
import timeConvertUtils from "@/mixins/timeConvertUtils";
</script>
